import { useMemo } from 'react';
import { useCurrentClientManager } from '../../context/CurrentClientManager';
export const useCanClientOnboardSubentities = () => {
    const { client } = useCurrentClientManager();
    const canOnboardSubEntities = useMemo(() => {
        return client?.entities.some((entity) => entity.onboardsSubEntities === true);
    }, [client]);
    return canOnboardSubEntities;
};
export const useEntitiesThatCannotOnboardSubentities = () => {
    const { client } = useCurrentClientManager();
    const entitiesWithoutOnboarding = useMemo(() => client?.entities
        .filter((entity) => entity.onboardsSubEntities === false)
        .map((entity) => entity.id), [client]);
    return entitiesWithoutOnboarding;
};
